import { ToolControls } from '@dashboard/components/dynamic-dashboard-wrapper/tool-controls';
import {
  ChartId,
  ChartIds,
} from '@dashboard/components/vessel-info/vessel-info-details/charts-tab/charts.model';
import { z } from 'zod';

const VesselChartIdSchema = z.enum(
  Object.values(ChartIds) as [ChartId, ...ChartId[]]
);
export const ToolControlKeySchema = z.enum(ToolControls);

export const ChartMetaSchema = z.object({
  key: VesselChartIdSchema,
  show: z.boolean().default(true),
});
export const ControlMetaSchema = z.object({
  key: ToolControlKeySchema,
  show: z.boolean().default(true),
});

export const DashboardConfigSchema = z
  .object({
    charts: z.array(ChartMetaSchema),
    controls: z.array(ControlMetaSchema),
  })
  .superRefine((cfg, ctx) => {
    // optional: prevent duplicate chart keys
    const chartSeen = new Set<string>();
    cfg.charts.forEach((chart, index) => {
      if (chartSeen.has(chart.key)) {
        ctx.addIssue({
          code: 'custom',
          message: `Duplicate chart key: ${chart.key}`,
          path: ['charts', index, 'key'],
        });
      }
      chartSeen.add(chart.key);
    });

    // optional: prevent duplicate control keys
    const controlSeen = new Set<string>();
    cfg.controls.forEach((control, index) => {
      if (controlSeen.has(control.key)) {
        ctx.addIssue({
          code: 'custom',
          message: `Duplicate control key: ${control.key}`,
          path: ['controls', index, 'key'],
        });
      }
      controlSeen.add(control.key);
    });
  });

export type ChartMeta = z.infer<typeof ChartMetaSchema>;
export type ControlMeta = z.infer<typeof ControlMetaSchema>;
export type DashboardConfig = z.infer<typeof DashboardConfigSchema>;
